import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { QueryClientProvider, QueryClient } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { LicenseManager } from 'ag-grid-enterprise';

import App from './App';
import ErrorBoundary from './shared/errorBoundaries/ErrorBoundary.component';
import store, { persistor } from './getStore';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

LicenseManager.setLicenseKey('Using_this_{AG_Grid}_Enterprise_key_{AG-115521}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{PricewaterhouseCoopers_Global_Licensing_Services_Corporation}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Tax_Lifecycle_Solutions_(TLS)}_only_for_{3}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{Tax_Lifecycle_Solutions_(TLS)}_need_to_be_licensed___{Tax_Lifecycle_Solutions_(TLS)}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{31_December_2026}____[v3]_[01]_MTc5ODY3NTIwMDAwMA==f0fe6c1dd1131c222f547c8200b4c3ef');

const root = createRoot(document.querySelector('#root'));
root.render(
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ErrorBoundary global>
          <App />
        </ErrorBoundary>
        <ReactQueryDevtools position="bottom-right" />
      </PersistGate>
    </Provider>
  </QueryClientProvider>
);
